
<p-dialog class="notification-popup" 
    header="Notification" 
    [(visible)]="isVisible"
    [modal]="true"
    [closable]="true" 
    [appendTo]="'body'"
    [draggable]="false"
    [resizable]="false"
    [blockScroll]="true"
    [baseZIndex]="1200"
    [style]="{ width: '800px', height: '250px' }"
    [breakpoints]="{ '960px': '90vw', '640px': '96vw' }"
    [contentStyle]="{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 'calc(250px - 120px)' }"
    [styleClass]="'notification-popup-size'" 
    (onHide)="onCloseModal()">

    <div class="content-section">  
       <div>{{ errorMessage }}</div>
       <div class="second-msg">{{ secondErrorMessage }} </div>
    </div>

    <div class="buttons-section">
        
        <button class="close-button formated-button" 
            (click)="onCloseModal()">Close</button>
    </div>

</p-dialog>

